<template>
	<div class="page7_main_layout">
		<div class="page7_main_img_1" >
<!-- 			<div style="
					font-size: 60px;
					color: #ffffff;
					font-weight: 600;
					margin-top: 10px;
					
				"
			>
				颠覆想象，视觉设备新革命：为千行百业注入无限可能
			</div> -->
		</div>

<!-- 		<div class="app_header_layout_phone">
			
			<div class="show_now_path_content_item" style="margin-left: 00px;cursor: pointer;font-size: 15px;" @click="return_page7_btn">
				行业应用
			</div>
			<div class="show_now_path_content_item_2">
				>
			</div>
			<div class="show_now_path_content_item" style="cursor: pointer;" @click="return_page7_btn">
				<span v-if="now_show_sub_data" style="font-size: 15px;">{{now_show_sub_data.title}}</span>
			</div>
			<div class="show_now_path_content_item_2">
				>
			</div>
			<div class="show_now_path_content_item" font-size: 15px;>
				<span v-if="now_show_item_data">{{now_show_item_data.title}}</span>
			</div>
		</div> -->
		<div class="app_header_layout">
			
			<div class="show_now_path_content_item" style="margin-left: 00px;cursor: pointer;" @click="return_page7_btn">
				行业应用
			</div>
			<div class="show_now_path_content_item_2">
				>
			</div>
			<div class="show_now_path_content_item" style="cursor: pointer;" @click="return_page7_btn">
				<!-- <span v-if="now_show_sub_data">{{now_show_sub_data.title}}</span> -->
				{{now_show_sub_data.title}}
			</div>
			<div class="show_now_path_content_item_2">
				>
			</div>
			<div class="show_now_path_content_item">
				{{now_show_item_data.title}}
				<!-- <span v-if="now_show_item_data">{{now_show_item_data.title}}</span> -->
			</div>
		</div>
		
		<div class="app_content_layout">
			<div class="app_content_main_title">
				{{now_show_item_data.title}}检测
			</div>
			<div class="app_content_introduce_title">
				场景简述
			</div>
			<div class="app_content_introduce_text">
				{{now_show_item_data.introduce_text}}
			</div>
			<div class="app_content_ability_title" v-show="now_show_item_data.ability_text!='-'">
				检测能力
			</div>
			<div class="app_content_ability_text" v-show="now_show_item_data.ability_text!='-'">
				{{now_show_item_data.ability_text}}

			</div>
			<div class="app_content_img page7_main_show_item_img_0_0" v-show="ap_sub==0&&ap_sub_item==0"></div>
			<div class="app_content_img page7_main_show_item_img_0_1" v-show="ap_sub==0&&ap_sub_item==1"></div>
			<div class="app_content_img page7_main_show_item_img_0_2" v-show="ap_sub==0&&ap_sub_item==2"></div>
			<div class="app_content_img page7_main_show_item_img_0_3" v-show="ap_sub==0&&ap_sub_item==3"></div>
			<div class="app_content_img page7_main_show_item_img_0_4" v-show="ap_sub==0&&ap_sub_item==4"></div>
			<div class="app_content_img page7_main_show_item_img_0_5" v-show="ap_sub==0&&ap_sub_item==5"></div>
			<div class="app_content_img page7_main_show_item_img_0_6" v-show="ap_sub==0&&ap_sub_item==6"></div>
			<div class="app_content_img page7_main_show_item_img_0_7" v-show="ap_sub==0&&ap_sub_item==7"></div>
			<div class="app_content_img page7_main_show_item_img_0_8" v-show="ap_sub==0&&ap_sub_item==8"></div>
			<div class="app_content_img page7_main_show_item_img_0_9" v-show="ap_sub==0&&ap_sub_item==9"></div>
			<div class="app_content_img page7_main_show_item_img_0_10" v-show="ap_sub==0&&ap_sub_item==10"></div>
			
			<div class="app_content_img page7_main_show_item_img_1_0" v-show="ap_sub==1&&ap_sub_item==0"></div>
			<div class="app_content_img page7_main_show_item_img_1_1" v-show="ap_sub==1&&ap_sub_item==1"></div>
			<div class="app_content_img page7_main_show_item_img_1_2" v-show="ap_sub==1&&ap_sub_item==2"></div>
			<div class="app_content_img page7_main_show_item_img_1_3" v-show="ap_sub==1&&ap_sub_item==3"></div>
			<div class="app_content_img page7_main_show_item_img_1_4" v-show="ap_sub==1&&ap_sub_item==4"></div>
			<div class="app_content_img page7_main_show_item_img_1_5" v-show="ap_sub==1&&ap_sub_item==5"></div>
			<div class="app_content_img page7_main_show_item_img_1_6" v-show="ap_sub==1&&ap_sub_item==6"></div>
			<div class="app_content_img page7_main_show_item_img_1_7" v-show="ap_sub==1&&ap_sub_item==7"></div>
			<div class="app_content_img page7_main_show_item_img_1_8" v-show="ap_sub==1&&ap_sub_item==8"></div>
			<div class="app_content_img page7_main_show_item_img_1_9" v-show="ap_sub==1&&ap_sub_item==9"></div>
			<div class="app_content_img page7_main_show_item_img_1_10" v-show="ap_sub==1&&ap_sub_item==10"></div>
			<div class="app_content_img page7_main_show_item_img_1_11" v-show="ap_sub==1&&ap_sub_item==11"></div>
			<div class="app_content_img page7_main_show_item_img_1_12" v-show="ap_sub==1&&ap_sub_item==12"></div>
			<div class="app_content_img page7_main_show_item_img_1_13" v-show="ap_sub==1&&ap_sub_item==13"></div>
			<div class="app_content_img page7_main_show_item_img_1_14" v-show="ap_sub==1&&ap_sub_item==14"></div>
			<div class="app_content_img page7_main_show_item_img_1_15" v-show="ap_sub==1&&ap_sub_item==15"></div>
			<div class="app_content_img page7_main_show_item_img_1_16" v-show="ap_sub==1&&ap_sub_item==16"></div>
			
			<div class="app_content_img page7_main_show_item_img_2_0" v-show="ap_sub==2&&ap_sub_item==0"></div>
			<div class="app_content_img page7_main_show_item_img_2_1" v-show="ap_sub==2&&ap_sub_item==1"></div>
			<div class="app_content_img page7_main_show_item_img_2_2" v-show="ap_sub==2&&ap_sub_item==2"></div>
			<div class="app_content_img page7_main_show_item_img_2_3" v-show="ap_sub==2&&ap_sub_item==3"></div>
			<div class="app_content_img page7_main_show_item_img_2_4" v-show="ap_sub==2&&ap_sub_item==4"></div>
			<div class="app_content_img page7_main_show_item_img_2_5" v-show="ap_sub==2&&ap_sub_item==5"></div>
			
			<div class="app_content_img page7_main_show_item_img_3_0" v-show="ap_sub==3&&ap_sub_item==0"></div>
			<div class="app_content_img page7_main_show_item_img_3_1" v-show="ap_sub==3&&ap_sub_item==1"></div>
			<div class="app_content_img page7_main_show_item_img_3_2" v-show="ap_sub==3&&ap_sub_item==2"></div>
			<div class="app_content_img page7_main_show_item_img_3_3" v-show="ap_sub==3&&ap_sub_item==3"></div>
			<div class="app_content_img page7_main_show_item_img_3_4" v-show="ap_sub==3&&ap_sub_item==4"></div>
			<div class="app_content_img page7_main_show_item_img_3_5" v-show="ap_sub==3&&ap_sub_item==5"></div>
			<div class="app_content_img page7_main_show_item_img_3_6" v-show="ap_sub==3&&ap_sub_item==6"></div>
			<div class="app_content_img page7_main_show_item_img_3_7" v-show="ap_sub==3&&ap_sub_item==7"></div>
			<div class="app_content_img page7_main_show_item_img_3_8" v-show="ap_sub==3&&ap_sub_item==8"></div>
			
			<div class="app_content_img page7_main_show_item_img_4_0" v-show="ap_sub==4&&ap_sub_item==0"></div>
			<div class="app_content_img page7_main_show_item_img_4_1" v-show="ap_sub==4&&ap_sub_item==1"></div>
			<div class="app_content_img page7_main_show_item_img_4_2" v-show="ap_sub==4&&ap_sub_item==2"></div>
			<div class="app_content_img page7_main_show_item_img_4_3" v-show="ap_sub==4&&ap_sub_item==3"></div>
			<div class="app_content_img page7_main_show_item_img_4_4" v-show="ap_sub==4&&ap_sub_item==4"></div>
			<div class="app_content_img page7_main_show_item_img_4_5" v-show="ap_sub==4&&ap_sub_item==5"></div>
			<div class="app_content_img page7_main_show_item_img_4_6" v-show="ap_sub==4&&ap_sub_item==6"></div>
			<div class="app_content_img page7_main_show_item_img_4_7" v-show="ap_sub==4&&ap_sub_item==7"></div>
			<div class="app_content_img page7_main_show_item_img_4_8" v-show="ap_sub==4&&ap_sub_item==8"></div>
			<div class="app_content_img page7_main_show_item_img_4_9" v-show="ap_sub==4&&ap_sub_item==9"></div>
			<div class="app_content_img page7_main_show_item_img_4_10" v-show="ap_sub==4&&ap_sub_item==10"></div>
			<div class="app_content_img page7_main_show_item_img_4_11" v-show="ap_sub==4&&ap_sub_item==11"></div>
			<div class="app_content_img page7_main_show_item_img_4_12" v-show="ap_sub==4&&ap_sub_item==12"></div>
			<div class="app_content_img page7_main_show_item_img_4_13" v-show="ap_sub==4&&ap_sub_item==13"></div>
			<div class="app_content_img page7_main_show_item_img_4_14" v-show="ap_sub==4&&ap_sub_item==14"></div>
			<div class="app_content_img page7_main_show_item_img_4_15" v-show="ap_sub==4&&ap_sub_item==15"></div>
			
			<div class="app_content_img page7_main_show_item_img_5_0" v-show="ap_sub==5&&ap_sub_item==0"></div>
			<div class="app_content_img page7_main_show_item_img_5_1" v-show="ap_sub==5&&ap_sub_item==1"></div>
			<div class="app_content_img page7_main_show_item_img_5_2" v-show="ap_sub==5&&ap_sub_item==2"></div>
			<div class="app_content_img page7_main_show_item_img_5_3" v-show="ap_sub==5&&ap_sub_item==3"></div>
			<div class="app_content_img page7_main_show_item_img_5_4" v-show="ap_sub==5&&ap_sub_item==4"></div>
			<div class="app_content_img page7_main_show_item_img_5_5" v-show="ap_sub==5&&ap_sub_item==5"></div>
			
			<div class="app_content_img page7_main_show_item_img_6_0" v-show="ap_sub==6&&ap_sub_item==0"></div>
			<div class="app_content_img page7_main_show_item_img_6_1" v-show="ap_sub==6&&ap_sub_item==1"></div>
			<div class="app_content_img page7_main_show_item_img_6_2" v-show="ap_sub==6&&ap_sub_item==2"></div>
			<div class="app_content_img page7_main_show_item_img_6_3" v-show="ap_sub==6&&ap_sub_item==3"></div>
			<div class="app_content_img page7_main_show_item_img_6_4" v-show="ap_sub==6&&ap_sub_item==4"></div>
			<div class="app_content_img page7_main_show_item_img_6_5" v-show="ap_sub==6&&ap_sub_item==5"></div>

		</div>
		<div class="app_page_btn_layout">
			<div class="app_page_previous_btn" 
				@click="page_previous_btn" 
				v-show="ap_sub_item!=0"
			>
				上一篇:{{previous_text}}
			</div>
			<div class="app_page_next_btn" 
				@click="page_next_btn" 
				v-show="ap_sub_item!=now_show_sub_data_show_list.length-1"
				
			>
				下一篇:{{next_text}}
			</div>
		</div>
	</div>
	<Footer></Footer>
</template>

<script>
	import request from "@/utils/request";
	import Footer from '@/components/Footer'
	
	export default{
		name:"page6",
		components:{
			Footer
		},
		data() {
			return{
				product_list_data_4:[],
				ap_sub:0,
				ap_sub_item:0,
				now_show_sub_data:{},
				now_show_sub_data_show_list:[],
				now_show_item_data:{},
				next_text:"",
				previous_text:"",
			}
		},
		mounted(){
			// 置顶
			document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0
			// 获取数据
			this.product_list_data_4 = this.$GLOBAL.product_list_data_4
			
			this.ap_sub = window.localStorage.getItem("ap_sub")
			this.ap_sub_item = window.localStorage.getItem("ap_sub_item")
			
			if(!this.ap_sub||!this.ap_sub_item){
				this.$router.push("/main/")
			}else{
				this.now_show_sub_data = this.product_list_data_4[this.ap_sub]
				this.now_show_sub_data_show_list = this.now_show_sub_data['show_list']
				this.now_show_item_data = this.now_show_sub_data_show_list[this.ap_sub_item]
				
				if(this.ap_sub_item!=0){
					this.previous_text = this.now_show_sub_data_show_list[parseInt(this.ap_sub_item)-1].title
				}
				if(this.ap_sub_item!=this.now_show_sub_data_show_list.length-1){
					this.next_text = this.now_show_sub_data_show_list[parseInt(this.ap_sub_item)+1].title
				}
			}
			
		},
		methods:{
			return_page7_btn(){
				this.$router.push("/main/industry_applications")
			},
			page_previous_btn(){

				this.ap_sub_item = parseInt(this.ap_sub_item) - 1
				window.localStorage.setItem("ap_sub_item",this.ap_sub_item)
				this.now_show_item_data = this.now_show_sub_data_show_list[this.ap_sub_item]
				
				if(this.ap_sub_item!=0){
					this.previous_text = this.now_show_sub_data_show_list[parseInt(this.ap_sub_item)-1].title
				}
				if(this.ap_sub_item!=this.now_show_sub_data_show_list.length-1){
					this.next_text = this.now_show_sub_data_show_list[parseInt(this.ap_sub_item)+1].title
				}
			},
			page_next_btn(){

				this.ap_sub_item = parseInt(this.ap_sub_item) + 1
				window.localStorage.setItem("ap_sub_item",this.ap_sub_item)
				this.now_show_item_data = this.now_show_sub_data_show_list[this.ap_sub_item]		
				
				if(this.ap_sub_item!=0){
					this.previous_text = this.now_show_sub_data_show_list[parseInt(this.ap_sub_item)-1].title
				}
				if(this.ap_sub_item!=this.now_show_sub_data_show_list.length-1){
					this.next_text = this.now_show_sub_data_show_list[parseInt(this.ap_sub_item)+1].title
				}
				
			},
		}
	}
</script>

<style>
</style>